import React, {Component} from 'react';
import {getJobViewFormFieldsByUserId} from '../../util/APIUtils';
import {SESSION_USER} from '../../constants';
import Loading from '../../common/Loading';
import NotFound from '../../common/NotFound';

import JobCalendar from './JobCalendar';
import JobExternal from './JobExternal';
import ServerError from '../../common/ServerError';

class JobSchedule extends Component {
    
      constructor(props) {
        super(props);
        this.state = {
            fieldsloading: true,
            peopleInfo:[],
            nowdatetime:'',
            currenttime:'',
            schedules:[],
              fields:[],
            resources:[]
        };
            
    }

   componentDidMount(){
   	     let user = JSON.parse(localStorage.getItem(SESSION_USER));
          
         // var jobObject=[];
   	      getJobViewFormFieldsByUserId(user.id).then(response => {
                    //    console.log(response);
                       if(response){ 
                        
                        /* if(response.unschedules){//here get all resouses in
                           for(var k in response.unschedules){
                           	           var unschedule=response.unschedules[k];
                                       var resource={
                                            id:unschedule.id,
                                            title:unschedule.title,
                                            type:0   //0 means unschedule //1 means schedule
                                       };
                                       jobObject.push(resource);

                           }
                             this.setState({resources:jobObject});
                         }*/
                         if(response.schedules){
                          this.setState({schedules:response.schedules});
                         }

                         if(response.resourceList){
                              this.setState({resources:response.resourceList});
                         }

                           if(response.peopleInfo){
                              this.setState({peopleInfo:response.peopleInfo});
                            }
                            if(response.nowDateTime){
                              this.setState({nowdatetime:response.nowDateTime});
                            }
                             if(response.currentTime){
                              this.setState({currenttime:response.currentTime});
                            }

                            
                              this.setState({fields:response,fieldsloading: false});
                        }     
                      
                }).catch(error => {
                   if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });
         

   } 


   render(){
     	if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

        if(this.state.fieldsloading) {
           return <Loading />;
        } 

    return (
           
                 <div className="row">   
                    <JobExternal peopleInfo={this.state.peopleInfo} />
                    <JobCalendar schedules={this.state.schedules} currenttime={this.state.currenttime} nowdatetime ={this.state.nowdatetime}  fields={this.state.fields} resources={this.state.resources} />  
                </div>
            

          );
  } 
}
export default JobSchedule;